var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:(_vm.height),attrs:{"src":require("../assets/brrzzz.png"),"srcset":require("../assets/brrzzz.png") + " 1x, " + require("../assets/brrzzz@2x.png") + " 2x, " + require("../assets/brrzzz@3x.png") + " 3x"}})])}
var staticRenderFns = []

export { render, staticRenderFns }